import React from "react";
import { useTranslation } from "react-i18next";
import CopyClipboard from "../main/CopyClipboard";
import { EyeIcon } from "@heroicons/react/24/outline";
import { getMyUserToken } from "../api/DeveloperAppApi";

const tokenPlaceHolder = "**********************************";

const MobileAppSetting = ({ appInfo }) => {
  const { t } = useTranslation();
  const { connected } = appInfo;
  const [myToken, setMyToken] = React.useState(tokenPlaceHolder);
  const showCopy = myToken !== tokenPlaceHolder;
  if (connected) {
    return (
      <div className={"space-y-2"}>
        <div className={"font-bold"}>{t("API Key")}</div>
        <div className={"space-y-2 align-middle"}>
          <div className={"w-full p-2 flex items-center space-x-2 cursor-pointer"}>
            <div className={"flex truncate"}>{myToken}</div>
            <div className={"min-w-48 flex items-center space-x-2"}>
              <EyeIcon
                className={"w-4"}
                onClick={() => {
                  getMyUserToken().then((data) => {
                    setMyToken(data.value);
                  });
                }}
              />
              {showCopy && <CopyClipboard copingText={myToken} />}
            </div>
          </div>
        </div>
      </div>
    );
  }
  return <div>{t("Mobile app is disabled.")}</div>;
};

export default MobileAppSetting;
